var _g, _g2, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 87,
    viewBox: "0 0 87 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.567936
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.4931 7.08984C63.6033 7.08984 79.906 23.3926 79.906 43.5028C79.906 63.6133 63.6033 79.9158 43.4931 79.9158C23.3828 79.9158 7.08008 63.6133 7.08008 43.5028C7.08008 23.3926 23.3828 7.08984 43.4931 7.08984Z",
    fill: "#B599FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.976684
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.5 1C66.972 1 86 20.0278 86 43.5C86 66.9722 66.972 86 43.5 86C20.0278 86 1 66.9722 1 43.5C1 20.0278 20.0278 1 43.5 1Z",
    stroke: "#B295FF",
    strokeWidth: 0.390526,
    strokeMiterlimit: 10
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.5806 19.6699C56.7192 19.6699 67.3866 30.3374 67.3866 43.4759C67.3866 56.6144 56.7192 67.2819 43.5806 67.2819C30.4421 67.2819 19.7747 56.6144 19.7747 43.4759C19.7747 30.3374 30.4421 19.6699 43.5806 19.6699Z",
    fill: "#9268FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5806 19.6699C56.7192 19.6699 67.3866 30.3374 67.3866 43.4759C67.3866 56.6144 56.7192 67.2819 43.5806 67.2819C30.4421 67.2819 19.7747 56.6144 19.7747 43.4759C19.7747 30.3374 30.4421 19.6699 43.5806 19.6699Z",
    stroke: "#9268FF",
    strokeWidth: 2.66793,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6897 35.8652L39.1744 51.3805L31.1705 43.3767",
    stroke: "white",
    strokeWidth: 4.93975,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.082893a9.svg";
export { ForwardRef as ReactComponent };